export enum Themes {
  INFORMATIE_OP_KAART = "Informatie presenteren op de kaart",
  KAARTBEDIENING = "Kaartbediening",
  KAARTLAGEN = "Kaartlagen",
  KAARTWEERGAVE_KIEZEN = "Kaartweergave kiezen",
  LEGENDA = "Legenda",
  WERKBALK = "Werkbalk",
  ZOEKEN = "Zoeken"
}
